import React from "react";
import "styles/legacy/UploadNewTitle.css";

interface UploadHeaderProps {
  onDiscardClick: () => void;
  onSaveDraft: () => void;
  onSubmitClick: () => void;
  onSaveChanges: () => void;
  onNavigationWithCleanup: (targetPath: string) => void;
  hasChanges: boolean;
  assetStatus: string;
  isEditing: boolean;
  savingDisabled?: boolean;
}

const UploadHeader: React.FC<UploadHeaderProps> = ({
  onDiscardClick,
  onSaveDraft,
  onSubmitClick,
  onSaveChanges,
  onNavigationWithCleanup,
  hasChanges,
  assetStatus,
  isEditing,
  savingDisabled = false,
}) => {
  const handleBackClick = () => {
    if (hasChanges) {
      onDiscardClick(); // open discard modal
    } else {
      onNavigationWithCleanup("/home/library"); // navigate with cleanup
    }
  };

  const isEditingPublished = isEditing && assetStatus === "Published";

  return (
    <div className="uploadflow-header">
      <h1 className="uploadflow-title">
        <button
          onClick={handleBackClick}
          className="svg-back-button"
          aria-label="Go back"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.0664 1.76367L3.58008 9.25H19.5V10.75H3.58203L4.43359 11.6035L11.0547 18.2373L10 19.293L0.707031 10L10.001 0.705078L11.0664 1.76367Z"
              fill="#FAFAFA"
              stroke="#FAFAFA"
            />
          </svg>
        </button>
        {isEditing ? "Edit title" : "Upload new title"}
      </h1>
      <div className="uploadflow-header-actions">
        <button className="discard-upload-btn" onClick={onDiscardClick}>
          Discard changes and exit
        </button>
        {isEditingPublished ? (
          <button className="save-changes-btn" onClick={onSaveChanges} disabled={savingDisabled}>
            Save changes
          </button>
        ) : (
          <>
            <button className="save-upload-btn" onClick={onSaveDraft} disabled={savingDisabled}>
              Save draft
            </button>
            <button className="submit-upload-btn" onClick={onSubmitClick} disabled={savingDisabled}>
              Submit for publishing
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default UploadHeader;
